<template>
  <div class="app-user-card">
    <div class="app-user-card__img">
      <img :src="img" alt="user avatar">
    </div>
    <div class="app-user-card__body">
      <span class="app-user-card__username">hi，{{ username }}</span>
      <h3 class="app-user-card__company">{{ company }}</h3>
      <!-- <span class="app-user-card__robot">智能客服：<b>小推</b></span> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppUserCard',
  props: {
    img: {
      type: String,
      default: ''
    },
    username: {
      type: String,
      default: ''
    },
    company: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.app-user-card {
  display: flex;
  align-items: center;

  &__img {
    overflow: hidden;
    width: 75px;
    height: 75px;
    border-radius: 50%;
    background-color: #eee;

    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__body {
    flex: 1;
    padding-left: 15px;
  }

  &__username {
    color: #999;
    font-size: 14px;
  }

  &__company {
    margin-top: 10px;
    margin-bottom: 0;
  }

  &__robot {
    display: block;
    margin-top: 10px;

    b {
      color: $primary-color;
    }
  }
}
</style>
